export const CssClasses = {
  fvError: 'gl-fv-error',
  fvFocused: 'gl-fv-focused',
}
